export function getOrSetGet <K, V>(m: Map<K, V>, k: K, d: V): V {
  let value = m.get(k);
  if (value == null) {
    m.set(k, d);
    value = d;
  }
  return value;
}
